import { jsx as _jsx } from "react/jsx-runtime";
import Chip from '@mui/material/Chip';
import { BubbleChatQuestionIcon } from 'hugeicons-react';
import { Stack, useTheme } from '@mui/material';
export default function FAQCardChip(_a) {
    var label = _a.label, setfaqDetailsDrawer = _a.setfaqDetailsDrawer, faq = _a.faq;
    var theme = useTheme();
    return (_jsx(Stack, { flexDirection: 'row', gap: 1, children: _jsx(Chip, { size: 'small', variant: 'soft', label: label, sx: {
                background: '#919EAB14',
                '& .MuiChip-label': {
                    fontSize: '13px',
                    fontWeight: 600,
                    color: theme.palette.text.secondary,
                    padding: '10px'
                }
            }, icon: _jsx(BubbleChatQuestionIcon, { height: '18px', width: '18px', color: theme.palette.text.secondary, style: { stroke: theme.palette.text.secondary } }), onClick: function () { return setfaqDetailsDrawer({ isOpen: true, faq: faq }); } }) }));
}
